import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const titlesMap = {
  '/': 'Home',
  '/about-us': 'About Us',
  '/partner-with-us': 'Partner with us',
  '/news-room': 'Newsroom',
  '/our-commitment': 'Our Commitment',
  '/booking': 'Booking',
  '/admin/login': 'Admin Login',
  '/admin': 'Admin Dashboard',
  '/api/beetzee/payment/success': 'Payment Success',
  '/api/beetzee/payment/failed': 'Payment Failed',
  '/api/beetzee/payment/cancelled': 'Payment Cancelled',
};

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = titlesMap[location.pathname] || '';

    document.title = `HiveRooms${pageTitle ? ` | ${pageTitle}` : ''}`;
  }, [location.pathname]);

  return null;
}

export default PageTitle;